function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoVertexWhite = function SvgLogoVertexWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 787.951 763.719",
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h205.518l110.388 124.664Z",
    transform: "matrix(1.33333 0 0 -1.33333 345.505 319.06)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m0 0 205.322-241.913-2.566 281.917Z",
    transform: "matrix(1.33333 0 0 -1.33333 0 404.792)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m0 0-35.781-237.236L290.755-86.243Z",
    transform: "matrix(1.33333 0 0 -1.33333 349.62 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m0 0-213.042-238.452 197.968 25.741z",
    transform: "matrix(1.33333 0 0 -1.33333 293.865 36.984)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m0 0 165.747-54.624-56.673 244.123Z",
    transform: "matrix(1.33333 0 0 -1.33333 471.245 620.254)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m0 0 15.024-272.575 88.539 93.362z",
    transform: "matrix(1.33333 0 0 -1.33333 295.407 387.245)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m0 0 65.535-229.749 49.21 339.351z",
    transform: "matrix(1.33333 0 0 -1.33333 634.958 340.681)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m0 0-72.005-92.393 232.13 28.6z",
    transform: "matrix(1.33333 0 0 -1.33333 453.378 640.528)"
  }));
};
export { SvgLogoVertexWhite as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIgogICB4bWxuczpjYz0iaHR0cDovL2NyZWF0aXZlY29tbW9ucy5vcmcvbnMjIgogICB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiCiAgIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgdmlld0JveD0iMCAwIDc4Ny45NTEwNSA3NjMuNzE4NjMiCgogICB4bWw6c3BhY2U9InByZXNlcnZlIgogICBpZD0ic3ZnMiIKICAgdmVyc2lvbj0iMS4xIj48bWV0YWRhdGEKICAgICBpZD0ibWV0YWRhdGE4Ij48cmRmOlJERj48Y2M6V29yawogICAgICAgICByZGY6YWJvdXQ9IiI+PGRjOmZvcm1hdD5pbWFnZS9zdmcreG1sPC9kYzpmb3JtYXQ+PGRjOnR5cGUKICAgICAgICAgICByZGY6cmVzb3VyY2U9Imh0dHA6Ly9wdXJsLm9yZy9kYy9kY21pdHlwZS9TdGlsbEltYWdlIiAvPjwvY2M6V29yaz48L3JkZjpSREY+PC9tZXRhZGF0YT48ZGVmcwogICAgIGlkPSJkZWZzNiIgLz48ZwogICAgIHRyYW5zZm9ybT0ibWF0cml4KDEuMzMzMzMzMywwLDAsLTEuMzMzMzMzMywtOTIwLjA0ODc4LDExMDguNjI4MikiCiAgICAgaWQ9ImcxMCI+PGcKICAgICAgIHRyYW5zZm9ybT0idHJhbnNsYXRlKDk0OS4xNjUsNTkyLjE3NjgpIgogICAgICAgaWQ9ImcxMiI+PHBhdGgKICAgICAgICAgaWQ9InBhdGgxNCIKICAgICAgICAgc3R5bGU9ImZpbGw6d2hpdGU7ZmlsbC1vcGFjaXR5OjE7ZmlsbC1ydWxlOm5vbnplcm87c3Ryb2tlOm5vbmUiCiAgICAgICAgIGQ9Ik0gMCwwIEggMjA1LjUxOCBMIDMxNS45MDYsMTI0LjY2NCBaIiAvPjwvZz48ZwogICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjkwLjAzNjYsNTI3Ljg3NykiCiAgICAgICBpZD0iZzE2Ij48cGF0aAogICAgICAgICBpZD0icGF0aDE4IgogICAgICAgICBzdHlsZT0iZmlsbDp3aGl0ZTtmaWxsLW9wYWNpdHk6MTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6bm9uZSIKICAgICAgICAgZD0iTSAwLDAgMjA1LjMyMiwtMjQxLjkxMyAyMDIuNzU2LDQwLjAwNCBaIiAvPjwvZz48ZwogICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOTUyLjI1Miw4MzEuNDcxMikiCiAgICAgICBpZD0iZzIwIj48cGF0aAogICAgICAgICBpZD0icGF0aDIyIgogICAgICAgICBzdHlsZT0iZmlsbDp3aGl0ZTtmaWxsLW9wYWNpdHk6MTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6bm9uZSIKICAgICAgICAgZD0iTSAwLDAgLTM1Ljc4MSwtMjM3LjIzNiAyOTAuNzU1LC04Ni4yNDMgWiIgLz48L2c+PGcKICAgICAgIHRyYW5zZm9ybT0idHJhbnNsYXRlKDkxMC40MzU1LDgwMy43MzI5KSIKICAgICAgIGlkPSJnMjQiPjxwYXRoCiAgICAgICAgIGlkPSJwYXRoMjYiCiAgICAgICAgIHN0eWxlPSJmaWxsOndoaXRlO2ZpbGwtb3BhY2l0eToxO2ZpbGwtcnVsZTpub256ZXJvO3N0cm9rZTpub25lIgogICAgICAgICBkPSJtIDAsMCAtMjEzLjA0MiwtMjM4LjQ1MiAxOTcuOTY4LDI1Ljc0MSB6IiAvPjwvZz48ZwogICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTA0My40NzA3LDM2Ni4yODAzKSIKICAgICAgIGlkPSJnMjgiPjxwYXRoCiAgICAgICAgIGlkPSJwYXRoMzAiCiAgICAgICAgIHN0eWxlPSJmaWxsOndoaXRlO2ZpbGwtb3BhY2l0eToxO2ZpbGwtcnVsZTpub256ZXJvO3N0cm9rZTpub25lIgogICAgICAgICBkPSJNIDAsMCAxNjUuNzQ3LC01NC42MjQgMTA5LjA3NCwxODkuNDk5IFoiIC8+PC9nPjxnCiAgICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5MTEuNTkxOCw1NDEuMDM3MSkiCiAgICAgICBpZD0iZzMyIj48cGF0aAogICAgICAgICBpZD0icGF0aDM0IgogICAgICAgICBzdHlsZT0iZmlsbDp3aGl0ZTtmaWxsLW9wYWNpdHk6MTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6bm9uZSIKICAgICAgICAgZD0ibSAwLDAgMTUuMDI0LC0yNzIuNTc1IDg4LjUzOSw5My4zNjIgeiIgLz48L2c+PGcKICAgICAgIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExNjYuMjU0OSw1NzUuOTYwNCkiCiAgICAgICBpZD0iZzM2Ij48cGF0aAogICAgICAgICBpZD0icGF0aDM4IgogICAgICAgICBzdHlsZT0iZmlsbDp3aGl0ZTtmaWxsLW9wYWNpdHk6MTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6bm9uZSIKICAgICAgICAgZD0ibSAwLDAgNjUuNTM1LC0yMjkuNzQ5IDQ5LjIxLDMzOS4zNTEgeiIgLz48L2c+PGcKICAgICAgIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwMzAuMDcwMywzNTEuMDc1MikiCiAgICAgICBpZD0iZzQwIj48cGF0aAogICAgICAgICBpZD0icGF0aDQyIgogICAgICAgICBzdHlsZT0iZmlsbDp3aGl0ZTtmaWxsLW9wYWNpdHk6MTtmaWxsLXJ1bGU6bm9uemVybztzdHJva2U6bm9uZSIKICAgICAgICAgZD0ibSAwLDAgLTcyLjAwNSwtOTIuMzkzIDIzMi4xMywyOC42IHoiIC8+PC9nPjwvZz48L3N2Zz4K";